import { WorkflowType } from '@/constants/dispositions';
import { useStore } from '@/store/store';

/**
 * Hook to check if the My Cases item should be shown in the sidebar.
 * Returns false if the selected program has PQC workflow type (Knipper organization).
 * My Cases is not applicable for PQC workflows.
 */
export const useShouldShowMyCasesPage = (): boolean => {
  const { getWorkflowsArray } = useStore();
  const workflows = getWorkflowsArray();

  // Hide My Cases for PQC workflow (Knipper organization)
  const hasPqcWorkflow =
    workflows?.some(workflow => workflow.workflow_type === WorkflowType.PQC) ?? false;

  return !hasPqcWorkflow;
};
